import ErpCost from 'components/erpCost/erpCost'
import { Helmet } from 'react-helmet'

const erpCostManagement = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Cost Management</title>
      </Helmet>
      <ErpCost />
    </>
  )
}

export default erpCostManagement
